import { render, staticRenderFns } from "./ShimmyPlus.vue?vue&type=template&id=6f70cc7c"
import script from "./ShimmyPlus.vue?vue&type=script&lang=ts"
export * from "./ShimmyPlus.vue?vue&type=script&lang=ts"
import style0 from "./ShimmyPlus.vue?vue&type=style&index=0&id=6f70cc7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports